import styled from 'styled-components';

export const SubTitulo = styled.h3`
  ${(props) => props.theme.layout.head.headline3};
  margin-bottom: 24px;
`;

export const UnidadeTable = styled.table`
  width: 100%;
  position: relative;
  font-family: 'Montserrat', sans-serif;

  thead,
  tbody {
    display: block;
    font-size: 0.75rem;
  }

  thead tr {
    display: flex;
    background: ${({ theme }) => theme.layout.color.background.blue};
    color: #fff;
    margin: 0;
    border-radius: 0 5px;
  }

  thead tr th {
    display: inline-block;
    font-weight: 600;
    line-height: 18px;
    text-align: left;
    padding: 10px 20px;
    color: #fff;
    flex: 1;
  }

  thead tr th:first-child {
    flex: 0 0 40px;
    width: 40px;
  }

  tbody td {
    height: auto;
    display: inline-block;
    flex: 1;
  }

  tbody td:first-child {
    flex: 0 0 40px;
    text-align: center;
  }
`;

export const HeaderCell = styled.th``;

export const UnidadeRow = styled.tr<{ $isExpanded: boolean }>`
  display: flex;
  padding: 10px 20px;
  border-radius: 0 5px;
  font-weight: 400;
  margin: 12px 0;
  width: 100%;
  box-sizing: border-box;
  cursor: pointer;
  background: ${({ $isExpanded }) => ($isExpanded ? '#F0F0F0' : '#fff')};
  border: 1px solid ${({ theme }) => theme.layout.color.complementares.gray_200};
  color: ${({ theme }) => theme.layout.color.complementares.gray_800};

  &:hover {
    background: ${({ $isExpanded, theme }) =>
      $isExpanded ? '#F0F0F0' : theme.layout.color.complementares.gray_200};
  }
`;

export const ExpandIcon = styled.span<{ $isExpanded: boolean }>`
  transition: transform 0.2s;
  display: inline-block;
  transform: ${({ $isExpanded }) =>
    $isExpanded ? 'rotate(90deg)' : 'rotate(0deg)'};
`;

export const ExpandedCell = styled.td`
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: 16px 24px;
  background: #fafafa;
`;

export const SubTable = styled.table`
  width: 100%;
  position: relative;

  thead,
  tbody {
    display: block;
    font-size: 0.75rem;
  }

  thead tr {
    display: flex;
    background: ${({ theme }) => theme.layout.color.background.blue};
    color: #fff;
    margin: 0;
    border-radius: 0 5px;
  }

  thead tr th {
    display: inline-block;
    font-weight: 600;
    line-height: 18px;
    text-align: left;
    padding: 10px 20px;
    color: #fff;
    flex: 1;
  }

  thead tr th:first-child {
    flex: 0 0 40px;
    width: 40px;
  }

  tbody tr {
    display: flex;
    padding: 10px 20px;
    border-radius: 0 5px;
    font-weight: 400;
    margin: 12px 0;
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid
      ${({ theme }) => theme.layout.color.complementares.gray_200};
    color: ${({ theme }) => theme.layout.color.complementares.gray_800};

    &:hover {
      background: ${({ theme }) => theme.layout.color.complementares.gray_200};
    }
  }

  tbody td {
    height: auto;
    display: inline-block;
    flex: 1;
  }

  tbody td:first-child {
    flex: 0 0 40px;
    text-align: center;
  }
`;

export const SubHeaderCell = styled.th``;

export const Cell = styled.td`
  height: auto;
  display: inline-block;
  flex: 1;
`;

export const ActionButton = styled.button<{ $disabled: boolean }>`
  background: ${({ $disabled, theme }) =>
    $disabled
      ? theme.layout.color.complementares.gray_200
      : theme.layout.color.main_colors.blue_500};
  color: ${({ $disabled }) => ($disabled ? '#999' : '#fff')};
  border: none;
  padding: 12px 24px;
  border-radius: 10px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  font-weight: 600;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 1.5px;
`;

export const LoadingWrapper = styled.p`
  text-align: center;
`;

export const EmptyMessage = styled.p`
  text-align: center;
  margin: 0;
`;
